export default __webpack_public_path__ + "static/media/DSC00583-1-1-point-5-768x511.568d8110.jpg";